<script setup>
import Vue, { inject, ref } from "vue";
import { useStore } from "@/utils/useStore";
const store = useStore();

const props = defineProps({
  questionAnswer: {
    type: Object,
    default: {},
  },
});
const showDescription = ref(false)

const toggleDescription = () => {
  showDescription.value = !showDescription.value;
};

const getSetModalVelue = inject('getSetModalVelue');

const editQuestion = (question) => {
  getSetModalVelue.value = question;
};

const deleteQuestion = async (questionId, questionAnswer) => {
    Vue.swal({
        title: "",
        html: `
        <div style="padding: 15px;">
          <svg width="65" height="65" viewBox="0 0 65 65" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="32.5" cy="32.5" r="32.5" fill="#FFF3ED"/>
            <path d="M41.5126 33.5178L42.1242 34.1781L42.1329 34.1701L42.1413 34.1618L41.5126 33.5178ZM32.9408 27.0604L32.2661 27.6561L32.9408 28.4203L33.6155 27.6561L32.9408 27.0604ZM24.3691 33.5178L23.7404 34.1618L23.7488 34.17L23.7573 34.1779L24.3691 33.5178ZM31.7382 40.3435L32.3507 39.6841L32.3498 39.6833L31.7382 40.3435ZM32.9408 40.8166L32.9401 41.7166L32.9416 41.7166L32.9408 40.8166ZM35.7649 40.0655C36.1291 39.7272 36.15 39.1578 35.8117 38.7936C35.4734 38.4295 34.9039 38.4085 34.5398 38.7468L35.7649 40.0655ZM31.7367 40.3451L32.3484 39.685L32.3484 39.685L31.7367 40.3451ZM24.0087 28.0475C24.193 27.5859 23.9683 27.0622 23.5067 26.8779C23.0451 26.6935 22.5214 26.9182 22.3371 27.3798L24.0087 28.0475ZM24.6448 24.4405C24.237 24.7246 24.1367 25.2855 24.4208 25.6934C24.7049 26.1012 25.2659 26.2016 25.6737 25.9174L24.6448 24.4405ZM36.7531 36.6906C36.388 37.0279 36.3656 37.5973 36.7029 37.9624C37.0402 38.3274 37.6097 38.3499 37.9747 38.0126L36.7531 36.6906ZM21.6364 20.3636C21.2849 20.0121 20.7151 20.0121 20.3636 20.3636C20.0121 20.7151 20.0121 21.2849 20.3636 21.6364L21.6364 20.3636ZM43.3636 44.6364C43.7151 44.9879 44.2849 44.9879 44.6364 44.6364C44.9879 44.2849 44.9879 43.7151 44.6364 43.3636L43.3636 44.6364ZM42.1413 34.1618C44.9706 31.3999 44.3007 27.3768 42.0859 25.1537C40.9586 24.0224 39.3918 23.3027 37.6166 23.4268C35.8415 23.5509 33.9936 24.5081 32.2661 26.4648L33.6155 27.6561C35.1168 25.9555 36.5547 25.3055 37.7422 25.2224C38.9297 25.1394 40.0022 25.6126 40.8107 26.4242C42.4675 28.087 42.8548 30.9499 40.884 32.8738L42.1413 34.1618ZM33.6155 26.4648C31.8881 24.5081 30.0402 23.5509 28.265 23.4268C26.4899 23.3027 24.923 24.0224 23.7958 25.1537C21.5809 27.3768 20.9111 31.3999 23.7404 34.1618L24.9978 32.8738C23.0269 30.9499 23.4142 28.087 25.0709 26.4242C25.8795 25.6126 26.952 25.1394 28.1395 25.2224C29.3269 25.3055 30.7648 25.9555 32.2661 27.6561L33.6155 26.4648ZM23.7575 34.1781L31.1266 41.0038L32.3498 39.6833L24.9807 32.8575L23.7575 34.1781ZM31.1256 41.0029C31.6369 41.4778 32.2894 41.7161 32.9401 41.7166L32.9416 39.9166C32.7285 39.9165 32.5175 39.8391 32.3507 39.6841L31.1256 41.0029ZM32.9416 41.7166C33.5922 41.7161 34.2448 41.4778 34.756 41.0029L33.5309 39.6841C33.3641 39.8391 33.1532 39.9165 32.9401 39.9166L32.9416 41.7166ZM34.755 41.0038L42.1242 34.1781L40.9011 32.8575L33.5319 39.6833L34.755 41.0038ZM34.5398 38.7468L33.5309 39.6842L34.756 41.0029L35.7649 40.0655L34.5398 38.7468ZM33.5309 39.6842C33.1976 39.9938 32.6821 39.9942 32.3484 39.685L31.125 41.0053C32.1495 41.9547 33.7328 41.9536 34.7561 41.0029L33.5309 39.6842ZM32.3484 39.685L24.9808 32.8577L23.7573 34.1779L31.125 41.0053L32.3484 39.685ZM24.9978 32.8738C23.5654 31.4755 23.3818 29.6169 24.0087 28.0475L22.3371 27.3798C21.4801 29.5255 21.7148 32.1844 23.7404 34.1618L24.9978 32.8738ZM25.6737 25.9174C26.4851 25.3522 27.4775 25.0817 28.5648 25.2752C29.6586 25.4699 30.9379 26.1515 32.2661 27.6561L33.6155 26.4648C32.0886 24.7351 30.4679 23.7857 28.8802 23.5031C27.286 23.2193 25.8152 23.6252 24.6448 24.4405L25.6737 25.9174ZM40.9018 32.8568L36.7531 36.6906L37.9747 38.0126L42.1234 34.1788L40.9018 32.8568ZM20.3636 21.6364L43.3636 44.6364L44.6364 43.3636L21.6364 20.3636L20.3636 21.6364Z" fill="#FF4820"/>
          </svg>
        <h3 class="title-modal">Você está deletando uma pergunta</h3>
        </div>
        <p class="descrption-modal"> Se você continuar com esta ação, a pergunta “${questionAnswer.question}” será removida das configurações das oportunidades, e essa alteração não poderá ser desfeita.</p>
        `,
        type: "danger",
        showCancelButton: true,
        confirmButtonText: "Deletar",
        cancelButtonText: "Cancelar",
        customClass: "sweet-container",
        confirmButtonClass: "button button-danger-2 mt-3 mb-3",
        cancelButtonClass: "button button-link-info mr-4 mt-3 mb-3",
        buttonsStyling: false,
        reverseButtons: true,
      }).then(async (result) => {
        if (result.isConfirmed) {
          await store.dispatch("questions/setDeleteQuestion",{questionId: questionId , getList : true}).then(async (r) => {
            console.log({r});
            if(r){
              await store.dispatch('opportunitiesProduct/dropQuestionList', questionId);
            }

            this.$bvToast.toast("Pergunta excluída com sucesso")

          }).catch(async (err) => {
            await store.dispatch('opportunitiesProduct/getOpportunitiesSettings');
          });
        }
      });
};
</script>

<template #title>
  <div class="header d-flex border-bottom">
    <div id="toast-container"></div>
    <div class="titles-descriptions">
      <div class="title">
        <span @click="toggleDescription()">{{ questionAnswer.question }}</span>
        <div class="product-options">
          <div>
            <svg
              @click="editQuestion(questionAnswer)"
              xmlns="http://www.w3.org/2000/svg"
              width="18"
              height="17"
              viewBox="0 0 18 17"
              fill="none"
            >
              <path
                d="M8.8208 15.3996H16.3208M12.5708 1.6496C12.9023 1.31808 13.352 1.13184 13.8208 1.13184C14.0529 1.13184 14.2828 1.17756 14.4973 1.2664C14.7118 1.35524 14.9066 1.48545 15.0708 1.6496C15.235 1.81376 15.3652 2.00863 15.454 2.22311C15.5428 2.43758 15.5886 2.66746 15.5886 2.8996C15.5886 3.13175 15.5428 3.36162 15.454 3.5761C15.3652 3.79057 15.235 3.98545 15.0708 4.1496L4.65413 14.5663L1.3208 15.3996L2.15413 12.0663L12.5708 1.6496Z"
                class="dark-500-stroke" 
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </div>
          
          <div @click="deleteQuestion(questionAnswer.id, questionAnswer)">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="21"
              height="23"
              viewBox="0 0 21 23"
              fill="none"
            >
              <path
                d="M1.3208 5.13101C0.906587 5.13101 0.570801 5.4668 0.570801 5.88101C0.570801 6.29522 0.906587 6.63101 1.3208 6.63101V5.13101ZM19.7823 6.63101C20.1966 6.63101 20.5323 6.29522 20.5323 5.88101C20.5323 5.4668 20.1966 5.13101 19.7823 5.13101V6.63101ZM3.62849 5.88101V5.13101H2.87849V5.88101H3.62849ZM17.4746 5.88101H18.2246V5.13101H17.4746V5.88101ZM4.07909 20.815L3.54881 21.3454L3.54882 21.3454L4.07909 20.815ZM5.95542 5.88101C5.95542 6.29522 6.2912 6.63101 6.70542 6.63101C7.11963 6.63101 7.45542 6.29522 7.45542 5.88101H5.95542ZM7.83192 2.39213L7.3016 1.8618L7.30159 1.8618L7.83192 2.39213ZM13.2712 2.39213L13.8015 1.8618L13.8015 1.8618L13.2712 2.39213ZM13.6477 5.88101C13.6477 6.29522 13.9835 6.63101 14.3977 6.63101C14.8119 6.63101 15.1477 6.29522 15.1477 5.88101H13.6477ZM8.99388 10.4986C8.99388 10.0844 8.65809 9.74864 8.24388 9.74864C7.82967 9.74864 7.49388 10.0844 7.49388 10.4986H8.99388ZM7.49388 16.6549C7.49388 17.0691 7.82967 17.4049 8.24388 17.4049C8.65809 17.4049 8.99388 17.0691 8.99388 16.6549H7.49388ZM13.6093 10.4986C13.6093 10.0844 13.2735 9.74864 12.8593 9.74864C12.4451 9.74864 12.1093 10.0844 12.1093 10.4986H13.6093ZM12.1093 16.6549C12.1093 17.0691 12.4451 17.4049 12.8593 17.4049C13.2735 17.4049 13.6093 17.0691 13.6093 16.6549H12.1093ZM1.3208 6.63101H19.7823V5.13101H1.3208V6.63101ZM3.62849 6.63101H17.4746V5.13101H3.62849V6.63101ZM16.7246 5.88101V19.7272H18.2246V5.88101H16.7246ZM16.7246 19.7272C16.7246 19.9362 16.6415 20.1368 16.4937 20.2847L17.5544 21.3453C17.9835 20.9162 18.2246 20.3341 18.2246 19.7272H16.7246ZM16.4937 20.2847C16.3459 20.4325 16.1452 20.5156 15.9362 20.5156V22.0156C16.5431 22.0156 17.1253 21.7744 17.5544 21.3453L16.4937 20.2847ZM15.9362 20.5156H5.16695V22.0156H15.9362V20.5156ZM5.16695 20.5156C4.95791 20.5156 4.75732 20.4325 4.60937 20.2846L3.54882 21.3454C3.97792 21.7744 4.55993 22.0156 5.16695 22.0156V20.5156ZM4.60938 20.2846C4.46159 20.1369 4.37849 19.9363 4.37849 19.7272H2.87849C2.87849 20.334 3.11958 20.9162 3.54881 21.3454L4.60938 20.2846ZM4.37849 19.7272V5.88101H2.87849V19.7272H4.37849ZM7.45542 5.88101V5.11178H5.95542V5.88101H7.45542ZM7.45542 5.11178C7.45542 4.29063 7.78162 3.5031 8.36225 2.92246L7.30159 1.8618C6.43965 2.72375 5.95542 3.89281 5.95542 5.11178H7.45542ZM8.36225 2.92246C8.94289 2.34183 9.73042 2.01562 10.5516 2.01562V0.515625C9.2269 0.515625 7.96782 1.02752 7.30159 1.8618L8.36225 2.92246ZM10.5516 2.01562C11.3727 2.01562 12.1603 2.34183 12.7409 2.92246L13.8015 1.8618C13.1353 1.02752 11.8762 0.515625 10.5516 0.515625V2.01562ZM12.7409 2.92246C13.3215 3.5031 13.6477 4.29063 13.6477 5.11178H15.1477C15.1477 3.89281 14.6635 2.72375 13.8015 1.8618L12.7409 2.92246ZM15.1477 5.11178V5.88101H13.6477V5.11178H15.1477ZM8.24388 10.4986V16.6549H9.74388V10.4986H8.24388ZM12.1093 10.4986V16.6549H13.6093V10.4986H12.1093Z"
                fill="#4E5150"
              />
            </svg>
          </div>
          <div>
            <svg
              @click="toggleDescription()"
              :class="{ 'rotate-icon': showDescription }"
              class="arrow"
              xmlns="http://www.w3.org/2000/svg"
              width="18"
              height="11"
              viewBox="0 0 18 11"
              fill="none"
            >
              <path
                d="M16.7823 9.26563L8.78235 1.26562L0.782349 9.26562"
                class="dark-500-stroke" 
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </div>
        </div>
      </div>
      <!-- Exibição da descrição -->
      <transition name="accordion">
        <div class="mt-3 description" v-if="showDescription">
          {{ questionAnswer.answer }}
        </div>
      </transition>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.gray-200-stroke { stroke: var(--gray-200); } 
.gray-200-fill { fill: var(--gray-200); }

.d-flex {
  display: flex;
  width: 100%;
}

.header {
  display: flex;
  padding: var(--spacing-10) 0 var(--spacing-10) 0;
  justify-content: space-between;

  .quetion-icon {
    background-color: var(--gray-10);
    width: var(--w-13);
    height: var(--h-13);
    align-items: center;
    justify-content: center;
    display: flex;
    border: none;
  }

  .titles-descriptions {
    display: grid;
    align-items: center;
    width: var(--w-full);

    .title {
      cursor: pointer;
      .product-options {
        display: flex;
        gap: 12px;
        svg {
          transition: transform 0.3s ease;
          cursor: pointer;
          width: var(--w-4);
        }
        .arrow {
          transform: rotate(180deg);
        }
        .rotate-icon {
          transform: rotate(0deg);
        }
      }
      display: flex;
      justify-content: space-between;
      font-size: var(--font-md);
      font-weight: var(--weight-semibold);
      line-height: var(--h-5);
      gap: var(--w-2);
      font-family: Montserrat;
    }

    .description {
      color: var(--gray-200);
      font-size: var(--font-sm);
      font-weight: var(--weight-normal);
      line-height: var(--h-6);
    }
  }
}
.accordion-enter-active,
.accordion-leave-active {
  transition: all 0.3s ease;
}
.accordion-enter,
.accordion-leave-to {
  max-height: 0;
  opacity: 0;
}
.accordion-enter-to,
.accordion-leave {
  max-height: 400px;
  opacity: 1;
}
</style>
